<template>
    <div class="sign-header" @click.self="toggleBox">
        <div class="fill" @click="official_website">
            <img class="sign-header-img" src="@/assets/img/logo.png"/>
        </div>

        <el-menu
                class="nav"
                mode="horizontal"
                text-color="#278E60"
                :default-active="defaultActive"
                active-text-color="#278E60"
                router
                @select="handleSelect"
        >
            <template v-for="item in navs">
                <el-menu-item :index="item.index" :key="item.index" class="el_item_me_top">
                    <span slot="title">{{ item.title }}
                        <el-badge :is-dot="item.value>0" class="item"></el-badge>
                    </span>
                </el-menu-item>
            </template>
        </el-menu>
        <div class="head_l">
            <div class="userinfo" @click="user_show=!user_show">
                <div class="photo">
                    <!--           <img class="el_img" :src="userInfo.imgUrl" />-->
                    <el-image class="el_img" v-if="userInfo.imgUrl" :src="userInfo.imgUrl" fit="contain">
                        <div slot="error">
                            <img v-if="userInfo.userType==1"
                                 src="@/assets/img/account/signup_choose_company_icon_01.png" alt/>
                            <img v-if="userInfo.userType==0" src="@/assets/img/account/signup_choose_single_icon_01.png"
                                 alt/>
                        </div>
                    </el-image>
                </div>
                <div class="user_name">
                    <div class="name">{{userInfo.userName||userInfo.userAccount}}</div>
                    <div class="type">
                        {{userInfo.userType==1?"企业用户":"个人用户"}}
                        <svg class="icon" aria-hidden="true">
                            <use
                                    :xlink:href="userInfo.authenStatus==1?'#el-icon-my-certificate':'#el-icon-my-nocertificate'"
                            />
                        </svg>
                    </div>
                </div>
                <div :class="['butn','el-icon-arrow-down' ,user_show?'open':'']"></div>
                <el-collapse-transition>
                    <div class="pull_down_box" v-show="user_show">
                        <div @click="show_sv" class="on">
                            <li class="el-icon-my-set"></li>
                            用户管理
                        </div>
                        <div @click="$SIF.logOut()">
                            <li class="el-icon-my-logout"></li>
                            退出
                        </div>
                    </div>
                </el-collapse-transition>
            </div>
            <div></div>
        </div>
    </div>
</template>
<script>
    export default {
        name: "Header",
        inject: ['reload'],
        data() {
            return {
                navs: [
                    {
                        index: "/workbench",
                        title: "我的工作台"
                    },
                    {
                        index: "/user",
                        title: "用户管理",
                        value: ''
                    },
                    {
                        index: "/document",
                        title: "文档管理"
                    },
                    // {
                    //   index: "/template",
                    //   title: "合同模板"
                    // }
                ],
                active_path: "",
                user_name: "Admin",
                user_type: "企业用户",
                user_show: false,
                userInfo: {},
            };
        },
        props: ['transmitData'],
        created() {
            this.get_userInfo();

        },
        watch: {
            transmitData(newVal, oldVal) {
                this.user_show = false;
            },
            $route(to, from) {
                this.user_show = false
            }
        },
        methods: {
            handleSelect(key, keyPath) {
                console.log(key, keyPath);
                if(key == '/user'){
                    this.reload()
                }
            },
            get_xinx() {
                this.$SIF.httpPost({
                    url: this.$SIF._serve.auth + "/authorize/queryPage",
                    data: {
                        entity: {
                            authorizeStatus: 10
                        },
                        pageBean: {
                            orderBy: '',
                            pageNum: 1,
                            pageSize: 300
                        }
                    },
                    succFun: res => {

                        if (res.data.list.length == 0) {
                            this.navs[1].value = 0
                        } else {
                            this.navs[1].value = res.data.list.length
                        }
                    },
                    failFun: res => {

                    }
                });
            },
            toggleBox: function () {
                this.user_show = false;  //通过控制showBox来控制box的显示与隐藏
            },
            show_sv() {
                this.user_show = false
                this.$router.push({path: '/user'})
            },
            official_website() {
                var pagename_one = window.location.host
                if (pagename_one.indexOf("aiosign.com") >= 0) {
                    this.new_url = 'https://' + pagename_one
                } else {
                    this.new_url = this.$SIF.get_url
                }
                window.location.href = this.new_url + '/index.html'
            },
            get_userInfo() {
                this.$SIF.getUserInfo({
                    succFun: res => {
                        this.userInfo = res.data;
                        // that.$store.commit("SET_USERINFO", res.data);
                        this.$SIF.setLocalStorage('userInfo', res.data)
                        if (this.userInfo.userType == 0) {
                            this.get_xinx()
                        }

                    }
                });
            }
        },
        computed: {
            defaultActive() {
                return "/" + this.$route.path.split("/")[1];
            }
        }
    };
</script>
<style scoped lang="scss">
    * {
        -webkit-touch-callout: none; /*系统默认菜单被禁用*/
        -webkit-user-select: none; /*webkit浏览器*/
        -khtml-user-select: none; /*早期浏览器*/
        -moz-user-select: none; /*火狐*/
        -ms-user-select: none; /*IE10*/
        user-select: none;
    }

    .fill {
        cursor: pointer;
    }

    input {
        -webkit-user-select: auto; /*webkit浏览器*/
    }

    textarea {
        -webkit-user-select: auto; /*webkit浏览器*/
    }

    .sign-header {
        display: flex;
        justify-content: space-between;
        background-color: $top-color;
        height: 70px;
        align-items: center;
        border-bottom: 1px #bcc7c1 solid;
        padding: 0px 4.8%;
        font-family: CN Medium;
    }

    .nav {
        border: none;
        display: flex;
    }

    .nav ul {
        white-space: nowrap;
    }

    .sign-header /deep/ .el-submenu__title,
    .sign-header /deep/ .el-menu-item {
        font-size: 16px;
        text-align: center;
        border: none;
    }

    .el-menu.el-menu--horizontal {
        border: none;
    }

    .sign-header-img {
        height: 45px;
    }

    .sign-header /deep/ .submenu__title.is-active,
    .sign-header /deep/ .el-menu-item.is-active {
        font-weight: bold;
        border: none;
    }

    .head_l {
        display: flex;
    }

    .userinfo {
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-right: 1px #979797 solid;
        position: relative;
        cursor: pointer;
    }

    .userinfo .photo {
        height: 50px;
        width: 50px;
        border-radius: 50%;
        overflow: hidden;
        margin-right: 20px;
        margin-left: 17px;
    }

    .el_img {
        width: 100%;
        height: 100%;
    }

    .userinfo .photo img {
        width: 100%;
        height: 100%;
    }

    .userinfo .butn {
        font-size: 20px;
        color: #3b6c56;
        font-weight: 700;
        margin-left: 19px;
        margin-right: 28px;

        -webkit-transition: all 0.3s ease-out;
        -moz-transition: all 0.3s ease-out;
        -ms-transition: all 0.3s ease-out;
        transition: all 0.3s ease-out;
    }

    .userinfo .butn.open {
        transform: rotate(180deg);
        -ms-transform: rotate(180deg);
        -moz-transform: rotate(180deg);
        -webkit-transform: rotate(180deg);
        -o-transform: rotate(180deg);
    }

    .pull_down_box {
        position: absolute;
        top: 60px;
        left: 0px;
        width: 100%;
        height: 94px;
        background: rgba(255, 255, 255, 1);
        box-shadow: 0px 2px 6px 0px rgba(135, 135, 135, 0.16);
        border-radius: 0px 0px 3px 3px;
        overflow: hidden;
        z-index: 9;
    }

    .pull_down_box > div {
        height: 47px;
        padding-left: 33px;
        font-size: 12px;
        color: #2b8d61;
        line-height: 47px;
    }

    .pull_down_box > div li {
        font-size: 18px;
        margin-right: 17px;
        vertical-align: middle;
    }

    .pull_down_box > div:hover {
        background: rgba(49, 202, 132, 0.1);
    }

    .user_name {
        color: #278e60;
        font-size: 16px;
        line-height: 24px;
    }

    .user_name .name {
        font-weight: 700;
    }
</style>